import type Mithril from 'mithril';
import Component from 'flarum/common/Component';
import Discussion from 'flarum/common/models/Discussion';
import Button from 'flarum/common/components/Button';
import abbreviateNumber from 'flarum/common/utils/abbreviateNumber';
import icon from 'flarum/common/helpers/icon';
import app from 'flarum/forum/app';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import classList from 'flarum/common/utils/classList';

export interface DiscussionVotesAttrs {
  discussion: Discussion;
}

export default class DiscussionVotes extends Component<DiscussionVotesAttrs> {
  oninit(vnode: Mithril.Vnode<DiscussionVotesAttrs, this>) {
    super.oninit(vnode);
  }

  view(vnode: Mithril.Vnode<DiscussionVotesAttrs, this>) {
    const { discussion } = this.attrs;
    const firstPost = discussion.firstPost();

    if (!firstPost) return null;

    // 不赞同
    const hasDownvoted = discussion.hasDownvoted();
    // 赞同
    const hasUpvoted = discussion.hasUpvoted();
    // 能否点击
    const canVote = !app.session.user || discussion.canVote();
    // 能否看见
    const seeVotes = discussion.seeVotes();
    // 帖子赞同数量
    const votes = discussion.votes();

    if (!seeVotes) return null;

    return (
      <div>
        <Button
          className={classList('Button', hasUpvoted && 'active')}
          icon="fas fa-caret-up"
          disabled={!canVote}
          onclick={() => {
            this.saveVote(firstPost, !hasUpvoted, false, (val) => {
              console.log(val);
            });
          }}
        >
          <span>
            {hasUpvoted ? '已赞同' : '赞同'} {abbreviateNumber(votes)}
          </span>
        </Button>

        <Button
          className={classList('Button', hasDownvoted && 'active')}
          disabled={!canVote}
          onclick={() => {
            this.saveVote(firstPost, false, !hasDownvoted, (val) => {
              console.log(val);
            });
          }}
        >
          {icon('fas fa-caret-down')}
        </Button>
      </div>
    );
  }

  saveVote(post, upvoted, downvoted, load, discussion = post.discussion()) {
    if (!app.session.user) {
      // We use this instead of showing LogInModal so that extensions can override it
      DiscussionControls.replyAction.call(discussion, true);
      return;
    } else if (discussion && !discussion.canVote() && !post.canVote()) {
      return;
    }

    if (upvoted && downvoted) {
      upvoted = false;
      downvoted = false;
    }

    if (load) load(true);

    m.redraw();

    return post
      .save([upvoted, downvoted, 'vote'])
      .then(
        () => null,
        () => null
      )
      .then(() => {
        if (load) load(false);

        if (discussion) {
          discussion.pushAttributes({
            votes: post.votes(),
          });
        }

        m.redraw();
      });
  }
}
